// Projects
export const REORDER_STORYBOARDS = 'REORDER_STORYBOARDS'
export const REORDER_STORYBOARDS_RESP = 'REORDER_STORYBOARDS_RESP'
export const MOVE_STORYBOARDS = 'MOVE_STORYBOARDS'
export const MOVE_STORYBOARDS_RESP = 'MOVE_STORYBOARDS_RESP'
